const features = [
  {
    icon: "ri-layout-grid-line",
    title: "分类清晰好查找",
    desc: "十大热门题材分类大全，恋爱、热血、悬疑、治愈一目了然，按喜好快速定位。",
    color: "bg-primary-500",
  },
  {
    icon: "ri-line-chart-line",
    title: "榜单实时更新",
    desc: "人气排行与热门榜单基于真实阅读数据实时刷新，热门趋势随时掌握。",
    color: "bg-accent-500",
  },
  {
    icon: "ri-vip-diamond-line",
    title: "免费专区畅读",
    desc: "精选海量免费漫画，零门槛直接阅读，追更也能轻松无负担。",
    color: "bg-secondary-500",
  },
  {
    icon: "ri-user-heart-line",
    title: "推荐懂你所需",
    desc: "新作推荐与相关作品智能匹配，帮你发现更多合口味的优质漫画。",
    color: "bg-primary-600",
  },
];

export default function Features() {
  return (
    <section className="border-y border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-medium uppercase tracking-wider text-primary-600">为什么选择我们</span>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">让每一部好漫画都能被看到</h2>
          <p className="mt-2 text-sm text-foreground-600">
            歪歪漫画网致力于打造分类清晰、榜单可信、免费易读的漫画内容聚合平台。
          </p>
        </div>
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((f) => (
            <div
              key={f.title}
              className="rounded-lg border border-background-200/70 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 hover:shadow-sm"
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${f.color} text-xl text-background-50`}>
                <i className={f.icon} />
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}